import { mapValues } from 'lodash';

import { AttributeDefinition } from 'domain/experiment/attribute';

export enum ErrorBandType {
  AUTO_MIN_MAX = 'auto-min-max',
  MANUAL_SYMMETRICAL = 'manual-symmetrical',
  MANUAL_TWO_SIDED = 'manual-two-sided',
  DISABLED = 'disabled',
}

export type ErrorBandsConfig = {
  type: ErrorBandType;
  options: {
    upperBandMetric?: AttributeDefinition;
    lowerBandMetric?: AttributeDefinition;
    upperLowerBandMetric?: AttributeDefinition;
  };
};

export type LegacyErrorBandsConfig = {
  type: ErrorBandType;
  options: {
    upperBoundMetric?: AttributeDefinition;
    lowerBoundMetric?: AttributeDefinition;
    upperLowerBoundMetric?: AttributeDefinition;
  };
};

export function isLegacyErrorBandsConfig(
  config: ErrorBandsConfig | LegacyErrorBandsConfig,
): config is LegacyErrorBandsConfig {
  return (
    'upperBoundMetric' in config.options ||
    'lowerBoundMetric' in config.options ||
    'upperLowerBoundMetric' in config.options
  );
}

export function convertLegacyErrorBandsConfig(config: LegacyErrorBandsConfig): ErrorBandsConfig {
  return {
    type: config.type,
    options: {
      upperBandMetric: config.options.upperBoundMetric,
      lowerBandMetric: config.options.lowerBoundMetric,
      upperLowerBandMetric: config.options.upperLowerBoundMetric,
    },
  };
}

export function getErrorBandsConfigByMetricNameHandlingLegacyKeyNames(
  bandsConfig?: Record<string, ErrorBandsConfig | LegacyErrorBandsConfig>,
): Record<string, ErrorBandsConfig> | undefined {
  if (!bandsConfig) {
    return bandsConfig;
  }

  return mapValues(bandsConfig, (config) =>
    config && isLegacyErrorBandsConfig(config) ? convertLegacyErrorBandsConfig(config) : config,
  );
}
